<template>
    <div class="single-product__media-feed">
        <div class="single-product__media-feed-section">
            <div class="left_content">
                <div class="left_content_premium">
                    <h2 class="mb-25px">{{mediaFeed.title}}</h2>
                    <p class="agp-light">{{mediaFeed.description}}</p>
                </div>
            </div>
            <div id="media-feed-carousel" class="splide splide--slide splide--ltr splide--draggable is-active is-overflow is-initialized" aria-label="Beautiful Images" role="region" aria-roledescription="carousel">
                <div class="splide__track splide__track--slide splide__track--ltr splide__track--draggable" id="media-feed-carousel-track" style="padding-left: 0px; padding-right: 0px;" aria-live="polite" aria-atomic="true" aria-busy="false">
                    <ul class="splide__list" id="media-feed-carousel-list" role="presentation" style="transform: translateX(0px);">
                        <li v-for="(item, index) in mediaFeed.slides" :key="index" class="splide__slide is-active is-visible" id="media-feed-carousel-slide01" role="group" aria-roledescription="slide" aria-label="1 of 4" style="margin-right: 12px; width: 47%;">
                            <img height="280px" :src="`${baseUrl}api/wp-content/uploads/${item.image_lazy || item.image}`"  :data-original_src="`${baseUrl}api/wp-content/uploads/${item.image}`"  :alt="item.alt ?? ''">
                            <div class="like_button" :class="{ active: isActive(index) }" @click="updateLikeCount(index, mediaFeed.term_id)" :data-value="item.likes" :data-option="isActive(index) ? 'up' : 'down'" :data-index="index" :data-collection-id="mediaFeed.term_id">
                                <span class="like_count">{{ item.likes }}</span>
                                <a class="likeButton active" :data-value="item.likes" data-option="up" :data-index="index" :data-collection-id="mediaFeed.term_id">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                                    <path d="M9.56766 3.31331L10 4.05759L10.4324 3.31329C11.6108 1.28455 13.8784 0.544119 15.8718 0.971185C17.8449 1.39393 19.5 2.94859 19.5 5.52315C19.5 7.2012 18.5196 9.01117 16.8292 11.0606C15.3233 12.8863 13.3215 14.8249 11.1241 16.9529C10.8681 17.2008 10.6095 17.4512 10.3487 17.7044L10.3481 17.705C10.2516 17.7991 10.1265 17.8462 10 17.8462C9.87351 17.8462 9.74844 17.7991 9.65191 17.705L9.65127 17.7044C9.39168 17.4524 9.13416 17.203 8.87919 16.956C6.68842 14.8342 4.68612 12.895 3.17793 11.067C1.48472 9.0147 0.5 7.20039 0.5 5.52315C0.5 2.95704 2.15137 1.39398 4.12228 0.965227C6.11157 0.532476 8.37901 1.26716 9.56766 3.31331Z" fill="#C60C46" stroke="#C60C46"></path>
                                    </svg>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_mediafeed.scss";
</style>

<script setup lang="ts">
    import Splide from "@splidejs/splide"
    import { onMounted } from "vue"
    const { $ajax } = useNuxtApp();
    const runtimeConfig = useRuntimeConfig();

    const baseUrl = runtimeConfig.public.BASE_URL;

    const props = defineProps(["data"]);
    const mediaFeed = computed(() => props.data);

    const activeButtons = ref<number[]>([]);
    const isActive = (index: number): boolean => {
        return activeButtons.value.includes(index);
    };

    const updateLikeCount = async (index: number, collectionId: number) => {
        const option = isActive(index) ? 'down' : 'up';
        const formData = new FormData();
        formData.append('action', 'increment_like_count');
        formData.append('index', index.toString());
        formData.append('collection_id', collectionId.toString());
        formData.append('option', option);

        const currentLikes = Number(mediaFeed.value.slides[index].likes);

        if (option === 'up') {
            mediaFeed.value.slides[index].likes = currentLikes + 1;
            activeButtons.value.push(index);
        } else {
            mediaFeed.value.slides[index].likes = currentLikes - 1;
            activeButtons.value = activeButtons.value.filter(i => i !== index);
        }
        try {
            const response = await $ajax.post('wp-admin/admin-ajax.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            // if (isActive(index)) {
            //     mediaFeed.value.slides[index].likes -= 1;
            //     activeButtons.value = activeButtons.value.filter(i => i !== index);
            // } else {
            //     mediaFeed.value.slides[index].likes += 1;
            //     activeButtons.value.push(index);
            // }
        } catch (err) {
            console.error('An error occurred', err);
        }
    };
    onMounted(() => {
        altLazyIO();
        var mediaFeedCarousel = new Splide("#media-feed-carousel", {
            perMove: 1,
            pagination: false,
            lazyLoad: 'sequential',
            gap: 12,
            fixedWidth: '47%',
            focus: 'center',
            drag: 'free',
            perPage: 2,
            arrows: true,
            breakpoints: {
                768: {
                    perPage: 1,
                    fixedWidth: '70%',
                },
                576: {
                    perPage: 1,
                }
            }
        });
        mediaFeedCarousel.mount()
    })
</script>